export default {
	state: {
		dadosContratacaoResgate: {}
	},
	getters: {
		"dadosContratacaoResgate": state => state.dadosContratacaoResgate
	},
	mutations: {
		setDadosContratacaoResgate(state, payload) {
			state.dadosContratacaoResgate = payload
		}
	},
	actions: {
		atualizarEstadoDadosContratacaoResgate({ commit }, payload) {
			commit('setDadosContratacaoResgate', payload)
		}
	}
};